import { InterruptionCreateFormValues, InterruptionType } from '../../types';
import useCreateInterruptionSubmit from '../useCreateInterruptionSubmit';

const useCreateCallbackInterruptionSubmit = () => {
  const { createInterruptionFromValues } = useCreateInterruptionSubmit();

  const createCallbackInterruption = async (values: InterruptionCreateFormValues) =>
    createInterruptionFromValues(values, InterruptionType.OnCallEmergency);

  return {
    createCallbackInterruption,
  };
};

export default useCreateCallbackInterruptionSubmit;
